/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/media-has-caption */
import React, { useState, useContext, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'
import {
  Container,
  Button,
  Row,
  Col,
  Form,
  InputGroup,
  Card,
  Image,
  Modal,
} from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faSearch,
  faVideo,
  faLink,
  faReply,
  faCirclePlus,
  faAd,
  faCloudArrowUp,
  faPlusCircle,
  faEye,
  faEyeSlash,
  faCircleExclamation,
  // faDisplay,
  faTrashAlt,
  faEdit,
} from '@fortawesome/free-solid-svg-icons'
import {
  AuthContext,
  // DraftContext,
  ToastContext,
  // DraftContext,
} from '../components/ContextProvider'
import apiServices from '../services/apiServices'
import { LoadingButton, Loading } from '../components'
import CreativeModal from './CreativeModal'
import { logoFull } from '../asset'

const defaultSettings = {
  playerSize: { width: 640, height: 360 },
  stickySize: { width: 300, height: 169 },
  ytId: '',
  videoUrl: '',
  vastUrl: '',
  interval: 10,
  disableSticky: false,
}

function Warn({ setting }) {
  const { size = 'md', show = false, handleClose } = setting

  return (
    <Modal
      style={{ zIndex: '1501' }}
      size={size}
      show={show !== false}
      onHide={() => handleClose(false)}
    >
      <Modal.Header
        className="AccFormModal justify-content-center text-center pt-4"
        closeButton
      >
        <Modal.Title>
          <h4>系統訊息</h4>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="d-flex AccformCard">
        <div className="assPermis w-100">
          <Form className="px-2 Form-card flex-grow-1">
            <Form.Group className="px-5 lh-md text-center text-dai">
              <FontAwesomeIcon
                icon={faCircleExclamation}
                style={{ height: '5rem' }}
                className="my-4"
              />
              <Form.Label className="w-100 fs-5 fw-bold text-center pb-4">
                確定要刪除嗎？
              </Form.Label>
            </Form.Group>
          </Form>
        </div>
      </Modal.Body>
      <Modal.Footer className="sendForm justify-content-center py-3">
        <Button variant="secondary" onClick={() => handleClose(false)}>
          取消
        </Button>
        <Button variant="dai" onClick={() => handleClose(show)}>
          確定
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

function VastModal({ setting }) {
  const { show, handleClose, media_id } = setting
  const [settingsData, setsettingsData] = useState(defaultSettings)
  const handleSettingsChange = (key, value, subKey = null) => {
    setsettingsData((prevData) => {
      if (subKey) {
        return {
          ...prevData,
          [key]: {
            ...prevData[key],
            [subKey]: value,
          },
        }
      }
      return {
        ...prevData,
        [key]: value,
      }
    })
  }

  const getSetting = async () => {
    const res = await apiServices.data({
      path: `vast/${media_id}`,
      method: 'get',
    })
    setsettingsData(
      Object.keys(defaultSettings).reduce(
        (prev, cur) => ({
          ...prev,
          [cur]: res[cur] || defaultSettings[cur],
        }),
        {}
      )
    )
  }
  useEffect(() => {
    getSetting()
  }, [media_id])

  const saveSettings = async () => {
    const res = await apiServices.data({
      path: `vast/${media_id}`,
      method: 'post',
      data: settingsData,
    })
    // console.log(res)
  }

  return (
    <Modal
      style={{ zIndex: '1501' }}
      show={show}
      size="lg"
      onHide={() => handleClose()}
      className="py-2 px-4"
    >
      <Modal.Header className="h5" closeButton>
        Vast setting
      </Modal.Header>
      <Modal.Body className="p-4 pb-5">
        <Row>
          {Object.entries(settingsData)
            .filter(([key, value]) => key !== 'disableSticky')
            .map(([key, value]) => (
              <Col xs={6} key={key} className="flex flex-col flex-grow-1">
                <Row>
                  <Col>
                    <Form.Label className="text-sm font-medium text-gray-700 mb-1">
                      {key}
                    </Form.Label>
                  </Col>
                  {key === 'stickySize' && (
                    <>
                      <Col xs={1} className="ms-auto text-nowrap">
                        啟用
                      </Col>
                      <Col xs={2} className="ms-1">
                        <Form.Check
                          type="switch"
                          lable="取消sticky"
                          checked={!settingsData.disableSticky}
                          onChange={() =>
                            handleSettingsChange(
                              'disableSticky',
                              !settingsData.disableSticky
                            )
                          }
                        />
                      </Col>
                    </>
                  )}
                </Row>
                {typeof value === 'object' &&
                'width' in value &&
                'height' in value ? (
                  <div className="flex space-x-2">
                    <div className="flex-1">
                      <Form.Label
                        htmlFor={`${key}-width`}
                        className="text-xs text-gray-500"
                      >
                        寬度
                      </Form.Label>
                      <Form.Control
                        type="number"
                        id={`${key}-width`}
                        value={settingsData[key]?.width ?? value.width}
                        disabled={
                          key === 'stickySize' && settingsData.disableSticky
                        }
                        onChange={(e) =>
                          handleSettingsChange(
                            key,
                            parseInt(e.target.value, 10),
                            'width'
                          )
                        }
                        className="mt-1 block w-full rounded-md text-sm border-gray-300 border border-1 p-2 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                      />
                    </div>
                    <div className="flex-1">
                      <Form.Label
                        htmlFor={`${key}-height`}
                        className="text-xs text-gray-500"
                      >
                        高度
                      </Form.Label>
                      <Form.Control
                        type="number"
                        id={`${key}-height`}
                        value={settingsData[key]?.height ?? value.height}
                        disabled={
                          key === 'stickySize' && settingsData.disableSticky
                        }
                        onChange={(e) =>
                          handleSettingsChange(
                            key,
                            parseInt(e.target.value, 10),
                            'height'
                          )
                        }
                        className="mt-1 block w-full rounded-md text-sm border-gray-300 border border-1 p-2 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                      />
                    </div>
                  </div>
                ) : key === 'vastUrl' ? (
                  <Form.Control
                    id={key}
                    as="textarea"
                    value={settingsData[key] ?? value}
                    onChange={(e) => handleSettingsChange(key, e.target.value)}
                    rows="5"
                    className="mt-1 block w-full rounded-md text-sm border-gray-300 border border-1 p-2 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                  />
                ) : (
                  <Form.Control
                    type="text"
                    id={key}
                    value={settingsData[key] ?? value}
                    onChange={(e) => handleSettingsChange(key, e.target.value)}
                    className="mt-1 block w-full rounded-md text-sm border-gray-300 border border-1 p-2 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                  />
                )}
              </Col>
            ))}
        </Row>
        <h4 className="text-base font-bold my-1">GAM 素材嵌入碼</h4>
        <div className="text-green-800">
          &lt;script
          src=&quot;https://aquarium.punwave.com/api/ads-player-loader.js?aid=
          {media_id}&amp;m=stage&quot; async&gt;&lt;/script&gt;
        </div>
        <h4 className="text-base font-bold my-1">預覽效果</h4>
        <div className="mt-1">
          <a
            className="text-sky-500"
            href={`api/bundle.html?aid=${media_id}&mode=stage`}
            target="_blank"
            rel="noreferrer"
          >
            DEMO
          </a>
          <iframe
            title="demo"
            src={`api/bundle.html?aid=${media_id}&mode=stage`}
          />
        </div>
        <Button
          onClick={saveSettings}
          className="mt-4 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
        >
          Save
        </Button>
      </Modal.Body>
      <Modal.Footer className="justify-content-center">
        {/* <Button
          className="ms-auto"
          style={{ boxShadow: 'none' }}
          variant="secondary"
          onClick={() => handleClose()}
        >
          取 消
        </Button> */}
        <Button
          className="me-auto"
          style={{ boxShadow: 'none' }}
          variant="outline-dai"
          onClick={() => handleClose(setsettingsData)}
        >
          確 認
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

function ProjectModal({ setting }) {
  const { show, form, defaultValue = {}, handleClose } = setting

  const [data, setdata] = useState({})
  const onDataChange = (e) =>
    setdata({ ...data, [e.target.name]: e.target.value })

  useEffect(() => {
    if (show) {
      setdata(
        form.reduce(
          (prev, cur) => ({
            ...prev,
            [cur.name]: defaultValue ? defaultValue[cur.name] : '',
          }),
          {}
        )
      )
    }
  }, [show, defaultValue])

  return (
    <Modal
      style={{ zIndex: '1501' }}
      show={show}
      onHide={() => handleClose()}
      className="py-2 px-4"
    >
      <Modal.Header className="h5" closeButton>
        {defaultValue.setting ? `編輯專案` : `新增專案`}
      </Modal.Header>
      <Modal.Body className="p-4 pb-5">
        {form.map((f, i) => (
          <React.Fragment key={i}>
            <Form.Label className="mt-3 mb-1 fw-bold text-chelonia">
              {f.label}
            </Form.Label>
            <Form.Control
              name={f.name}
              type={f.type}
              value={data[f.name] || ''}
              onChange={onDataChange}
              placeholder={f.placeholder}
            />
          </React.Fragment>
        ))}
      </Modal.Body>
      <Modal.Footer className="justify-content-center">
        <Button
          className="ms-auto"
          style={{ boxShadow: 'none' }}
          variant="secondary"
          onClick={() => handleClose()}
        >
          取 消
        </Button>
        <Button
          className="me-auto"
          style={{ boxShadow: 'none' }}
          variant="dai"
          onClick={() => handleClose(data)}
        >
          確 認
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

function Home() {
  const [searchKeyword, setSearchKeyword] = useState('')
  const { auth, setAuth } = useContext(AuthContext)
  const { setToast } = useContext(ToastContext)
  const navigate = useNavigate()

  const [reveal, setReveal] = useState(false)
  const [data, setData] = useState({ email: '', password: '' })
  const onDataChange = (event) =>
    setData({ ...data, [event.target.name]: event.target.value })

  const handleLogin = async () => {
    const { token } = await apiServices.login(data)
    if (!token) {
      setToast({ show: true, text: '登 入 失 敗' })
      return
    }
    document.cookie = `token=${token}; Domain=${window.location.hostname}; Path=/;`
    const { user } = await apiServices.me()
    setAuth({ authed: true, ...JSON.parse(user) })
  }

  // const [showCreative, setShowCreative] = useState(false)
  // const handleShowCreative = () => setShowCreative(true)
  // const handleCloseCreative = () => setShowCreative(false)

  const [projects, setProjects] = useState([])
  const getProjects = async () => {
    const res = await apiServices.data({ path: `file`, method: 'get' })
    setProjects(res)
  }
  useEffect(() => {
    getProjects()
  }, [])

  const addProject = async (value) => {
    const res = await apiServices.data({
      path: `file`,
      method: 'post',
      data: value,
    })
    // console.log(res)
    getProjects()
  }

  const handleDeleteProject = async (id) => {
    const res = await apiServices.data({
      path: `file/${id}`,
      method: 'delete',
    })
    await getProjects()
    return res
  }

  const form = [
    {
      name: 'name',
      label: '專案名稱',
      placeholder: '請輸入專案名稱...',
      type: 'text',
    },
    {
      name: 'description',
      label: '專案標籤',
      placeholder: '請輸入標籤或備註內容...',
      type: 'text',
    },
  ]

  const [show, setshow] = useState(false)
  const handleClose = (value) => {
    setshow(false)
    if (!value) return
    addProject(value)
  }

  const [projectId, setProjectId] = useState('')
  const [medias, setMedias] = useState([])
  const getMedias = async (id) => {
    const res = await apiServices.data({
      path: `file/medias/${id}`,
      method: 'get',
    })
    setMedias(res)
  }
  useEffect(() => {
    if (projectId) getMedias(projectId)
  }, [projectId])

  const [showVast, setshowVast] = useState({})
  const handleShowVast = async (media_id) => {
    setshowVast({
      show: true,
      media_id,
      handleClose: async (newSetting) => {
        if (newSetting) console.log(newSetting)
        setshowVast({
          ...showVast,
          show: false,
        })
      },
    })
  }

  const [creatives, setcreatives] = useState([])
  const getCreatives = async (id) => {
    const res = await apiServices.data({
      path: `creative/list/${id}`,
      method: 'get',
    })
    setcreatives(res)
  }

  const handleDeleteCreative = async (id) => {
    const res = await apiServices.data({
      path: `creative/${id}`,
      method: 'delete',
    })
    await getCreatives(projectId)
    return res
  }
  // console.log(creatives)

  const [showCreative, setShowCreative] = useState({
    show: false,
    handleClose: () => {
      setShowCreative({ ...showCreative, show: false })
    },
  })

  useEffect(() => {
    if (projectId && !showCreative.show) {
      getMedias(projectId)
      getCreatives(projectId)
    }
  }, [projectId, showCreative.show])

  const ref = useRef(null)
  const [tempFile, setTempFile] = useState(null)
  useEffect(() => {
    const handleUpload = async () => {
      const formData = new FormData()
      formData.append('file', tempFile)
      await apiServices.data({
        path: `file/${projectId}`,
        method: 'post',
        data: formData,
        contentType: 'multipart/form-data',
      })
      getMedias(projectId)
    }
    if (tempFile) handleUpload()
  }, [tempFile])

  const fields = [
    {
      label: '帳號',
      type: 'text',
      name: 'email',
      placeholder: '帳號',
    },
    {
      label: '密碼',
      type: 'password',
      name: 'password',
      placeholder: '密碼',
    },
  ]

  const [showWarn, setshowWarn] = useState({
    show: false,
    func: () => {},
  })

  return (
    <Container className="h-100 w-100 d-flex flex-column position-relative p-4">
      <Loading setting={{ time: 50, show: false, step: '下載圖片中......' }} />

      {auth.authed ? (
        <>
          <Row className="mb-4">
            <Col className="d-flex pe-0">
              <InputGroup>
                <Form.Control
                  placeholder="請輸入關鍵字以搜尋..."
                  value={searchKeyword}
                  onChange={(e) => setSearchKeyword(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' && !e.isComposing) e.preventDefault()
                  }}
                />
                <Button variant="outline-dai">
                  <FontAwesomeIcon icon={faSearch} />
                </Button>
              </InputGroup>
            </Col>
            <Col xs={5} className="d-flex">
              {projectId ? (
                <>
                  <Button
                    className="w-100 ms-auto me-2"
                    variant="dai-dark"
                    onClick={() => ref.current.click()}
                  >
                    上傳影片&ensp;
                    <FontAwesomeIcon icon={faCloudArrowUp} />
                  </Button>
                  <Button
                    className="w-100 ms-auto me-2"
                    variant="dai-dark"
                    onClick={() =>
                      setShowCreative({
                        ...showCreative,
                        show: true,
                      })
                    }
                  >
                    新增創意版位&ensp;
                    <FontAwesomeIcon icon={faPlusCircle} />
                  </Button>
                  <Button
                    className="w-100 me-2"
                    variant="dai-dark"
                    onClick={() => setProjectId('')}
                  >
                    回專案列表&ensp;
                    <FontAwesomeIcon icon={faReply} />
                  </Button>
                  <input
                    ref={ref}
                    style={{ visibility: 'hidden', width: '0', height: '0' }}
                    type="file"
                    onChange={(e) => setTempFile(e.target.files[0])}
                  />
                </>
              ) : (
                <Button
                  className="w-100 ms-auto"
                  variant="dai-dark"
                  onClick={() => setshow(true)}
                >
                  新建專案&ensp;
                  <FontAwesomeIcon icon={faCirclePlus} />
                </Button>
              )}
            </Col>
          </Row>

          {projectId ? (
            <Row className="p-0" style={{ overflowY: 'auto' }}>
              {medias.map(({ media_id, setting }) => (
                <Col
                  xs={4}
                  key={media_id}
                  className="position-relative px-3 pb-4"
                >
                  <Card className="h-100 w-100">
                    <Card.Body className="p-4" style={{ height: '28vh' }}>
                      {setting.src?.name ? (
                        <video width="auto" height="100%" controls>
                          <source src={`api/file/${setting.src.name}`} />
                        </video>
                      ) : (
                        <div className="w-100 h-100 d-flex">
                          <FontAwesomeIcon
                            icon={faVideo}
                            className="text-dai-white h-25 m-auto"
                          />
                        </div>
                      )}
                    </Card.Body>
                    <Card.Footer>
                      <Row className="text-nowrap">
                        {/* <Col xs={2}>名稱</Col> */}
                        <Col className="text-start">
                          {setting.src.name?.split('_')[1]}
                        </Col>
                        <Col xs={1} className="px-0">
                          <FontAwesomeIcon
                            onClick={() => handleShowVast(media_id)}
                            className="btn"
                            icon={faAd}
                          />
                        </Col>
                        <Col xs={2} className="px-0">
                          <FontAwesomeIcon
                            onClick={() => {
                              const cb = navigator.clipboard
                              cb.writeText(
                                `https://aquarium.punwave.com/api/file/${setting.src.name}`
                              )
                            }}
                            className="btn"
                            icon={faLink}
                          />
                        </Col>
                      </Row>
                    </Card.Footer>
                  </Card>
                </Col>
              ))}
              {creatives
                .filter(({ setting }) => {
                  const keyword = searchKeyword.trim().toLowerCase()
                  return (
                    !keyword ||
                    setting?.name?.toLowerCase().includes(keyword) ||
                    setting?.type?.toLowerCase().includes(keyword) ||
                    setting?.srcs?.some(
                      (src) =>
                        (typeof src.label === 'string' &&
                          src.label.toLowerCase().includes(keyword)) ||
                        (typeof src.file === 'string' &&
                          src.file.toLowerCase().includes(keyword))
                    )
                  )
                })
                .map(({ creative_id, setting }) => (
                  <Col
                    xs={4}
                    key={creative_id}
                    className="position-relative px-3 pb-4 rounded"
                  >
                    <Card>
                      <Card.Body
                        className="w-100"
                        style={{
                          // width: '350px',
                          height: '320px',
                          // height: '25vh',
                        }}
                      >
                        <Row className="h-50 overflow-hidden">
                          <img
                            alt=""
                            className="m-auto"
                            width="h-100"
                            height="w-100"
                            src={`${
                              setting.srcs.find(
                                (src) =>
                                  src && src.type && src.type.includes('image')
                              )?.file || ''
                            }`}
                          />
                        </Row>
                        <Row className="text-nowrap h-50 border-top pt-3">
                          {/* <Col xs={2}>名稱</Col> */}
                          <Col xs={12} className="text-start">
                            <h4>{setting.name || '未命名'}</h4>
                          </Col>
                          <Col xs={12} className="text-start">
                            {setting.type} - 手機
                          </Col>
                          <Col xs={1} className="px-0 ms-auto">
                            <FontAwesomeIcon
                              onClick={() =>
                                setShowCreative({
                                  ...showCreative,
                                  ...setting,
                                  creative_id,
                                  show: true,
                                })
                              }
                              className="btn"
                              title="編輯"
                              icon={faEdit}
                            />
                          </Col>
                          <Col xs={1} className="px-0 ms-3">
                            <FontAwesomeIcon
                              onClick={() => {
                                window.open(
                                  `${window.origin}/api/preview?aid=${creative_id}&type=${setting.category}`
                                )
                              }}
                              className="btn"
                              title="預覽"
                              icon={faEye}
                            />
                          </Col>
                          <Col xs={1} className="px-0 ms-3">
                            <FontAwesomeIcon
                              onClick={() => {
                                const cb = navigator.clipboard
                                cb.writeText(
                                  `<script async type="text/javascript" charset="utf-8" src="${window.origin}/api/ad/${creative_id}"></script>`
                                )
                                setToast({
                                  show: true,
                                  text: '已 複 製 adtag 到 剪 貼 簿',
                                })
                              }}
                              className="btn"
                              title="取得tag"
                              icon={faLink}
                            />
                          </Col>
                          <Col xs={1} className="px-0 ms-3 me-3">
                            <FontAwesomeIcon
                              onClick={() =>
                                setshowWarn({
                                  show: true,
                                  func: () => handleDeleteCreative(creative_id),
                                })
                              }
                              className="btn"
                              title="刪除"
                              icon={faTrashAlt}
                            />
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
            </Row>
          ) : (
            <Row>
              {projects
                .filter(({ setting }) => {
                  const keyword = searchKeyword.trim().toLowerCase()
                  return (
                    !keyword ||
                    setting?.name?.toLowerCase().includes(keyword) ||
                    setting?.description?.toLowerCase().includes(keyword)
                  )
                })
                .map(({ project_id, setting }) => (
                  <Col
                    xs={12}
                    key={project_id}
                    className="position-relative px-3 pb-2"
                  >
                    <Card className="project_card">
                      <Card.Footer>
                        <Row
                          className="text-nowrap"
                          onClick={() => setProjectId(project_id)}
                        >
                          <Col xs={8} className="text-start my-auto small">
                            {setting.name}
                          </Col>
                          <Col xs={2} className="text-start my-auto small">
                            #{setting.description}
                          </Col>
                          <Col xs={2} className="text-start my-auto small">
                            <FontAwesomeIcon
                              onClick={(e) => {
                                e.stopPropagation()
                                setshowWarn({
                                  show: true,
                                  func: () => handleDeleteProject(project_id),
                                })
                              }}
                              className="btn"
                              title="刪除"
                              icon={faTrashAlt}
                            />
                          </Col>
                        </Row>
                      </Card.Footer>
                    </Card>
                  </Col>
                ))}
            </Row>
          )}
        </>
      ) : (
        <>
          <Image
            className="mt-auto mx-auto mb-2"
            src={logoFull}
            style={{ height: '18rem', width: 'auto' }}
          />
          <div className="d-flex w-100 mb-auto" style={{ height: '20%' }}>
            <Form className="py-3 px-5 mx-auto d-flex flex-column">
              {fields.map((field) => (
                <Form.Group key={field.name} className="d-flex mb-2">
                  {/* <Form.Label>{field.label}</Form.Label> */}
                  {field.type === 'password' ? (
                    <InputGroup
                      id="defaultBorder"
                      className="rounded input-group-transparent-addon w-100"
                    >
                      <Form.Control
                        name={field.name}
                        type={reveal ? 'text' : field.type}
                        onChange={onDataChange}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' && !e.isComposing) handleLogin()
                        }}
                        placeholder={field.placeholder}
                      />
                      <InputGroup.Text>
                        <FontAwesomeIcon
                          className="fs-6"
                          style={{
                            right: '10',
                            top: '50',
                            bottom: '50',
                            cursor: 'pointer',
                          }}
                          title={reveal ? '點擊以隱藏密碼' : '點擊以顯示密碼'}
                          icon={reveal ? faEye : faEyeSlash}
                          onClick={() => setReveal(!reveal)}
                        />
                      </InputGroup.Text>
                    </InputGroup>
                  ) : (
                    <Form.Control
                      name={field.name}
                      type={field.type}
                      onChange={onDataChange}
                      placeholder={field.placeholder}
                    />
                  )}
                </Form.Group>
              ))}
              <LoadingButton
                size="sm"
                className="mx-auto my-2"
                variant="outline-dai"
                onClick={handleLogin}
                btnText="登入"
              />
              <div className="d-flex">
                <span
                  className="w-100 mx-auto small"
                  style={{
                    cursor: 'pointer',
                    textDecoration: 'underline',
                  }}
                  onClick={() => navigate('/register')}
                  aria-hidden
                >
                  註冊
                </span>
              </div>
            </Form>
          </div>
        </>
      )}
      <ProjectModal
        setting={{
          show,
          form,
          defaultValue: {},
          handleClose,
        }}
      />
      <VastModal setting={showVast} />
      <CreativeModal
        setting={{
          ...showCreative,
          handleUpload: async (file) => {
            console.log('is this triggered?')
            const formData = new FormData()
            formData.append('file', file)
            const uploaded = await apiServices.data({
              path: `creative/material`,
              method: 'post',
              data: formData,
              contentType: 'multipart/form-data',
              params: {
                projectId,
              },
            })
            console.log(uploaded)
            return `/api/file/${uploaded}`
          },
          handleUploadSettings: async (value) => {
            console.log(showCreative)
            const { creative_id } = showCreative
            await apiServices.data({
              path: creative_id
                ? `creative/${projectId}/${creative_id}`
                : `creative/${projectId}`,
              method: creative_id ? 'put' : 'post',
              data: value,
            })
            getCreatives(projectId)
          },
        }}
      />
      <Warn
        setting={{
          show: showWarn.show,
          handleClose: (value) => {
            if (value) showWarn.func()
            setshowWarn({
              show: false,
              func: () => {},
            })
          },
        }}
      />
    </Container>
  )
}

Warn.propTypes = {
  setting: PropTypes.shape().isRequired,
}

ProjectModal.propTypes = {
  setting: PropTypes.shape().isRequired,
}

VastModal.propTypes = {
  setting: PropTypes.shape().isRequired,
}

export default Home
